import React from 'react'
import {FormGroup, ControlLabel, FormControl, HelpBlock} from 'react-bootstrap'

/**
 * Helper method for quickly making form fields.
 *
 * @param {Object} props - Expects id, groupClass, label, help, additional props are attached to the <FormControl />
 * @returns Formatted input for the field group
 */
export const FieldGroup = (props) => {
  const {id, groupClass, label, help, ...rest} = props
  return (
    <FormGroup controlId={id} className={groupClass}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...rest} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/helpers/form.js